import React, { useContext } from "react";
import Button from "react-bootstrap/Button";
import ListGroup from "react-bootstrap/ListGroup";
import GoogleIcon from "../../../images/icons/icons8-google-48.png";
import GitHubIcon from "../../../images/icons/icons8-github-48.png";
import FacebookIcon from "../../../images/icons/icons8-facebook-48.png";
import WhatsappIcon from "../../../images/icons/icons8-whatsapp-48.png";
import YoutubeIcon from "../../../images/icons/icons8-youtube-48.png";
import TwitterIcon from "../../../images/icons/icons8-twitter-48.png";
import DiscordIcon from "../../../images/icons/icons8-discord-48.png";
import "./RightSideNav.css";
import BrandCarousel from "../BrandCarousel/BrandCarousel";
import { AuthContext } from "../../../Contexts/AuthProvider/AuthProvider";
import { GoogleAuthProvider } from "firebase/auth";
const RightSideNav = () => {
  const { providerLogin } = useContext(AuthContext);
  const googleLogin = new GoogleAuthProvider();

  const handleGoogleLogin = () => {
    providerLogin(googleLogin)
      .then((result) => {
        const user = result.user;
        console.log(user);
      })
      .catch((error) => console.error(error));
  };

  return (
    <div>
      <div>
        <Button
          onClick={handleGoogleLogin}
          variant="outline-info text-black mb-3 w-100"
        >
          <img className="iconImage" src={GoogleIcon} alt="" /> Login with
          Google
        </Button>
        <Button variant="outline-dark w-100">
          <img className="iconImage" src={GitHubIcon} alt="" /> Login with
          GitHub
        </Button>
      </div>
      <div>
        <h2 className="mt-5 mb-3">Find Us On</h2>
        <ListGroup>
          <ListGroup.Item className="flex align-items-center mb-3 shadow">
            <img className="listIcon me-2" src={FacebookIcon} alt="" />
            Facebook
          </ListGroup.Item>
          <ListGroup.Item className="flex align-items-center mb-3 shadow">
            <img className="listIcon me-2" src={WhatsappIcon} alt="" />
            Whatsapp
          </ListGroup.Item>
          <ListGroup.Item className="flex align-items-center mb-3 shadow">
            <img className="listIcon me-2" src={YoutubeIcon} alt="" />
            YouTube
          </ListGroup.Item>
          <ListGroup.Item className="flex align-items-center mb-3 shadow">
            <img className="listIcon me-2" src={TwitterIcon} alt="" />
            Twitter
          </ListGroup.Item>
          <ListGroup.Item className="flex align-items-center mb-3 shadow">
            <img className="listIcon me-2" src={DiscordIcon} alt="" />
            Discord
          </ListGroup.Item>
        </ListGroup>
      </div>
      <div>
        <BrandCarousel></BrandCarousel>
      </div>
    </div>
  );
};

export default RightSideNav;
